import { usePermission } from '@1823-partners/core';

/*
 * Server gate for CRE writes, unchanged from pam-master cre_server.
 * A permission hint only: the backend remains the enforcer.
 */
export const CRE_WRITE = 'cre.loans:write';
export const CRE_WRITE_ROLE = 'cre_editor';
export const NO_CRE_WRITE_MESSAGE =
  `You do not have permission to edit CRE loans — request the ${CRE_WRITE_ROLE} role from the permissions menu`;

// Preserve the old permissive-while-unknown hint. An unavailable permission
// center should not make a granted user's edit controls look permanently gated;
// the backend still returns 403 when they really lack the grant.
export const useCanWriteCre = () =>
  usePermission(CRE_WRITE, { allowWhileUnknown: true });
